<template>
  <app-loader v-if="loggedInWithoutUserInfo" />
  <template v-else>
    <component :is="layout" :isHealth="true">
      <router-view />
    </component>
    <notifications :position="position" />
  </template>
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout'
import HealthAuthLayout from '@/layouts/HealthAuthLayout'
import MainLayout from '@/layouts/MainLayout'
import TosLayout from '@/layouts/TosLayout'
import AppLoader from '@/components/common/AppLoader'

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
    position() {
      return window.innerWidth < 900 ? 'top' : 'bottom center'
    },
    loggedInWithoutUserInfo() {
      return this.$store.getters.GET_LOGGED_IN && !this.$store.getters.GET_CURRENT_USER_UUID
    },
  },
  components: {
    EmptyLayout,
    HealthAuthLayout,
    MainLayout,
    TosLayout,
    AppLoader,
  },
  created() {
    this.$store.commit('SET_AGENT', 'ha')
  },
  mounted() {
    if (this.loggedInWithoutUserInfo) {
      this.$store.dispatch('SET_CURRENT_USER')
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/main.scss';

.vue-notification-group {
  width: 440px !important;
  border-radius: 50px !important;

  @media only screen and (max-width: $tablet-size) {
    width: 100% !important;
    margin-top: 24px;
  }
}

.vue-notification-template {
  background: rgba(21, 46, 57, 0.88) !important;
  border: none !important;
  border-radius: 50px !important;
}

.notification-content {
  font-size: 15px !important;
  text-align: center !important;
  line-height: 22px;
}

.vue-notification {
  .notification-title {
    /*...*/
  }

  // style for content
  .notification-content {
    /*...*/
  }
}
</style>
